export default "__VITE_ASSET__D03UJi1G__"